module.exports = __webpack_public_path__ + "static/media/Sai-Paridhi-CF-Ad.fae8be6b.jpg";